const NativeFields = {
  Decimal: {
    type: 'Decimal',
    returnType: 'Decimal',
  },
  Int: {
    type: 'int',
    returnType: 'int',
  },
  String: {
    type: 'str',
    returnType: 'str',
  },
  Float: {
    type: 'float',
    returnType: 'float',
  },
  Date: {
    type: 'date',
    returnType: 'date',
  },
  DateTime: {
    type: 'datetime',
    returnType: 'date',
  },
  Time: {
    type: 'time',
    returnType: 'date',
  },
  Boolean: {
    type: 'bool',
    returnType: 'bool',
  },
};

// Model descriptors
const BandaDeValorSchema = {
  type: 'object',
  name: 'BandaDeValor',
  properties: {
    id: NativeFields.Int,
    banda: NativeFields.Int,
    valor: NativeFields.Decimal,
  },
  returnType: 'object',
  description: '',
};

const CategoriaDePredioSchema = {
  type: 'object',
  name: 'CategoriaDePredio',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const CategoriaDeRechazoSchema = {
  type: 'object',
  name: 'CategoriaDeRechazo',
  properties: {
    id: NativeFields.Int,
    categoria: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const TipoDeDominioSchema = {
  type: 'object',
  name: 'TipoDeDominio',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const TipoDeSueloSchema = {
  type: 'object',
  name: 'TipoDeSuelo',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const RegimenDePropiedadSchema = {
  type: 'object',
  name: 'RegimenDePropiedad',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const UsoDePredioSchema = {
  type: 'object',
  name: 'UsoDePredio',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const CalculoDeValorSchema = {
  type: 'object',
  name: 'CalculoDeValor',
  properties: {
    id: NativeFields.Int,
    descripcion_terreno: NativeFields.String,
    valor_terreno: NativeFields.Decimal,
    descripcion_construccion: NativeFields.String,
    valor_construccion: NativeFields.Decimal,
    valor_catastral: NativeFields.Decimal,
  },
  returnType: 'object',
  description: '',
};

const CalidadDeLaConstruccionSchema = {
  type: 'object',
  name: 'CalidadDeLaConstruccion',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const TipoDeLaConstruccionSchema = {
  type: 'object',
  name: 'TipoDeLaConstruccion',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const EstadoDeLaConstruccionSchema = {
  type: 'object',
  name: 'EstadoDeLaConstruccion',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const ClasificacionDeLaConstruccionSchema = {
  type: 'object',
  name: 'ClasificacionDeLaConstruccion',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
    anio: NativeFields.Int,
    valor: NativeFields.Decimal,
    tipo_de_la_construccion: TipoDeLaConstruccionSchema,
    calidad_de_la_construccion: CalidadDeLaConstruccionSchema,
    estado_de_la_construccion: EstadoDeLaConstruccionSchema,
  },
  returnType: 'object',
  description: '',
};

const ClaveDePredioSchema = {
  type: 'object',
  name: 'ClaveDePredio',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const ConfiguracionDeClaveSchema = {
  type: 'object',
  name: 'ConfiguracionDeClave',
  properties: {
    id: NativeFields.Int,
    es_principal: NativeFields.Boolean,
    es_alfanumerica: NativeFields.Boolean,
    es_opcional: NativeFields.Boolean,
    es_requerido: NativeFields.Boolean,
    longitud_minima: NativeFields.Int,
    longitud_maxima: NativeFields.Int,
    clave_de_predio: ClaveDePredioSchema,
  },
  returnType: 'object',
  description: '',
};

const ConstruccionSchema = {
  type: 'object',
  name: 'Construccion',
  properties: {
    id: NativeFields.Int,
    superficie_de_construccion: NativeFields.Float,
    anio_de_construccion: NativeFields.Int,
    nivel_de_construccion: NativeFields.Int,
    observaciones: NativeFields.String,
    clasificacion_de_la_construccion: ClasificacionDeLaConstruccionSchema,
  },
  returnType: 'object',
  description: '',
};

const FactoresEspecialesSchema = {
  type: 'object',
  name: 'FactorEspeciales',
  properties: {
    id: NativeFields.Int,
    factor_de_fondo: NativeFields.Decimal,
    factor_de_irregularidad: NativeFields.Decimal,
    factor_de_area: NativeFields.Decimal,
    factor_de_topografia: NativeFields.Decimal,
    factor_de_descripcion: NativeFields.Decimal,
  },
  returnType: 'object',
  description: '',
};

const MeritoYDemeritoSchema = {
  type: 'object',
  name: 'MeritoYDemerito',
  properties: {
    id: NativeFields.Int,
    merito: NativeFields.Boolean,
    demerito: NativeFields.Boolean,
    terreno_neutro: NativeFields.Boolean,
    terreno: NativeFields.Boolean,
    construccion: NativeFields.Boolean,
    descripcion: NativeFields.String,
    anio: NativeFields.Int,
    porcentaje: NativeFields.Float,
  },
  returnType: 'object',
  description: '',
};

const PadronSchema = {
  type: 'object',
  name: 'Padron',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const ContentTypeSchema = {
  type: 'object',
  name: 'Padron',
  properties: {
    id: NativeFields.Int,
    model: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const ParticipeSchema = {
  type: 'object',
  name: 'Participe',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
    porcentaje: NativeFields.Int,
    padron: PadronSchema,
    content_type_participe: ContentTypeSchema,
    object_id_participe: NativeFields.Int,
  },
  returnType: 'object',
  description: '',
};

const TasaDAPRuralSchema = {
  type: 'object',
  name: 'TasaDAPRural',
  properties: {
    id: NativeFields.Int,
    rango_inicial: NativeFields.Float,
    rango_final: NativeFields.Float,
    anio: NativeFields.Int,
    cuota_anual: NativeFields.Float,
  },
  returnType: 'object',
  description: '',
};

const TasaDAPUrbanoSchema = {
  type: 'object',
  name: 'TasaDAPUrbano',
  properties: {
    id: NativeFields.Int,
    rango_inicial: NativeFields.Float,
    rango_final: NativeFields.Float,
    anio: NativeFields.Int,
    cuota_anual: NativeFields.Float,
  },
  returnType: 'object',
  description: '',
};

const TasaDeConstruccionDePredioUrbanoSchema = {
  type: 'object',
  name: 'TasaDeConstruccionDePredioUrbano',
  properties: {
    id: NativeFields.Int,
    rango_inicial: NativeFields.Float,
    rango_final: NativeFields.Float,
    anio: NativeFields.Int,
    es_cuota_fija: NativeFields.Boolean,
    cuota_fija: NativeFields.Float,
    tasa: NativeFields.Float,
  },
  returnType: 'object',
  description: '',
};

const TasaDeConstruccionDePredioRuralSchema = {
  type: 'object',
  name: 'TasaDeConstruccionDePredioRural',
  properties: {
    id: NativeFields.Int,
    rango_inicial: NativeFields.Float,
    rango_final: NativeFields.Float,
    anio: NativeFields.Int,
    es_cuota_fija: NativeFields.Boolean,
    cuota_fija: NativeFields.Float,
    tasa: NativeFields.Float,
  },
  returnType: 'object',
  description: '',
};

const ZonaHomogeneaSchema = {
  type: 'object',
  name: 'ZonaHomogenea',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
    descripcion: NativeFields.String,
    zona_rural: NativeFields.Boolean,
    anio: NativeFields.Int,
    valor: NativeFields.Decimal,
    tipo_de_suelo: TipoDeSueloSchema,
  },
  returnType: 'object',
  description: '',
};

const TasaDePredioRuralSchema = {
  type: 'object',
  name: 'TasaDePredioRural',
  properties: {
    id: NativeFields.Int,
    hectarea: NativeFields.Int,
    anio: NativeFields.Int,
    es_cuota_fija: NativeFields.Boolean,
    cuota_fija: NativeFields.Float,
    tasa: NativeFields.Float,
    zona_homogenea: ZonaHomogeneaSchema,
  },
  returnType: 'object',
  description: '',
};

const TasaDePredioUrbanoSchema = {
  type: 'object',
  name: 'TasaDePredioUrbano',
  properties: {
    id: NativeFields.Int,
    construido: NativeFields.Boolean,
    rango_inicial: NativeFields.Float,
    rango_final: NativeFields.Float,
    anio: NativeFields.Int,
    es_cuota_fija: NativeFields.Boolean,
    cuota_fija: NativeFields.Float,
    tasa: NativeFields.Float,
  },
  returnType: 'object',
  description: '',
};

const TerrenoDelPredioSchema = {
  type: 'object',
  name: 'TerrenoDelPredio',
  properties: {
    id: NativeFields.Int,
    superficie_privada_del_terreno: NativeFields.Float,
    superficie_de_terreno_comun: NativeFields.Float,
    medida_del_frente: NativeFields.Float,
    medida_del_fondo: NativeFields.Float,
    valor_del_area_inscrita: NativeFields.Float,
    altura_topografica: NativeFields.Float,
    posicion: NativeFields.Int,
    area_aprovechable: NativeFields.Float,
    base_del_fondo: NativeFields.Float,
    base_del_frente: NativeFields.Float,
    base_de_la_area: NativeFields.Float,
    tipo_de_predio: NativeFields.String,
    superficie_total_del_terreno: NativeFields.Float,
    unidad_de_medida_de_la_superficie: NativeFields.String,
    factor_de_frente: NativeFields.Decimal,
    zona_homogenea_principal: ZonaHomogeneaSchema,
    zona_homogenea: ZonaHomogeneaSchema,
    factores_especiales: FactoresEspecialesSchema,
  },
  returnType: 'object',
  description: '',
};

const CatalogoDeValorSchema = {
  type: 'object',
  name: 'CatalogoDeValor',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const UMASchema = {
  type: 'object',
  name: 'UMA',
  properties: {
    id: NativeFields.Int,
    anio: NativeFields.Int,
    valor_diario: NativeFields.Float,
    valor_mensual: NativeFields.Float,
    valor_anual: NativeFields.Float,
  },
  returnType: 'object',
  description: '',
};

const PeriodoSchema = {
  type: 'object',
  name: 'Periodo',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const CatalogoDeMesSchema = {
  type: 'object',
  name: 'CatalogoDeMes',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const CPPSchema = {
  type: 'object',
  name: 'CPP',
  properties: {
    id: NativeFields.Int,
    valor: NativeFields.Decimal,
    periodo: PeriodoSchema,
    mes: CatalogoDeMesSchema,
  },
  returnType: 'object',
  description: '',
};

const INPCSchema = {
  type: 'object',
  name: 'INPC',
  properties: {
    id: NativeFields.Int,
    valor: NativeFields.Decimal,
    periodo: NativeFields.Int,
    mes: CatalogoDeMesSchema,
  },
  returnType: 'object',
  description: '',
};

const SalarioMinimoSchema = {
  type: 'object',
  name: 'SalarioMinimo',
  properties: {
    id: NativeFields.Int,
    inicio_de_vigencia: NativeFields.Date,
    salario_minimo_nominal: NativeFields.Float,
    salario_minimo_real: NativeFields.Float,
    variacion_real: NativeFields.Float,
  },
  returnType: 'object',
  description: '',
};

const CatalogoDeCanalesDePagoSchema = {
  type: 'object',
  name: 'CatalogoDeCanalesDePago',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const BancoSchema = {
  type: 'object',
  name: 'Banco',
  properties: {
    id: NativeFields.Int,
    nombre: NativeFields.String,
    RFC: NativeFields.String,
    razon_social: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const TipoDeCuentaBancariaSchema = {
  type: 'object',
  name: 'TipoDeCuentaBancaria',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const CatalogoDeMetodoDePagoSchema = {
  type: 'object',
  name: 'CatalogoDeMetodoDePago',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const CuentaDeBancoSchema = {
  type: 'object',
  name: 'CuentaDeBanco',
  properties: {
    id: NativeFields.Int,
    sucursal: NativeFields.String,
    finalidad: NativeFields.String,
    numero_de_cuenta: NativeFields.String,
    observaciones: NativeFields.String,
    banco: BancoSchema,
    metodo_de_pago: CatalogoDeMetodoDePagoSchema,
    tipo_de_cuenta_bancaria: TipoDeCuentaBancariaSchema,
  },
  returnType: 'object',
  description: '',
};

const TipoDePagoSchema = {
  type: 'object',
  name: 'TipoDePago',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
    predeterminado: NativeFields.Boolean,
    pedir_datos_de_operacion: NativeFields.Boolean,
    requisitos: NativeFields.String,
    concepto: NativeFields.String,
    ingreso_a_cuenta: NativeFields.Boolean,
    utilizar_terminales: NativeFields.Boolean,
    cuenta_ingreso: NativeFields.Int,
    cuenta_banco: CuentaDeBancoSchema,
    clave: CatalogoDeMetodoDePagoSchema,
  },
  returnType: 'object',
  description: '',
};

const CanalDePagoSchema = {
  type: 'object',
  name: 'CanalDePago',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
    descripcion: NativeFields.String,
    catalogo_de_canal_de_pago: CatalogoDeCanalesDePagoSchema,
    tipo_de_pago: TipoDePagoSchema,
  },
  returnType: 'object',
  description: '',
};

const SectorEmpresarialSchema = {
  type: 'object',
  name: 'SectorEmpresarial',
  properties: {
    id: NativeFields.Int,
    codigo: NativeFields.String,
    titulo: NativeFields.String,
    descripcion: NativeFields.String,
    incluye: NativeFields.String,
    excluye: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const SubSectorEmpresarialSchema = {
  type: 'object',
  name: 'SubSectorEmpresarial',
  properties: {
    id: NativeFields.Int,
    codigo: NativeFields.Int,
    titulo: NativeFields.String,
    descripcion: NativeFields.String,
    incluye: NativeFields.String,
    excluye: NativeFields.String,
    sector_empresarial: SectorEmpresarialSchema,
  },
  returnType: 'object',
  description: '',
};

const RamaEmpresarialSchema = {
  type: 'object',
  name: 'RamaEmpresarial',
  properties: {
    id: NativeFields.Int,
    codigo: NativeFields.Int,
    titulo: NativeFields.String,
    descripcion: NativeFields.String,
    incluye: NativeFields.String,
    excluye: NativeFields.String,
    sub_sector_empresarial: SubSectorEmpresarialSchema,
  },
  returnType: 'object',
  description: '',
};

const SubRamaEmpresarialSchema = {
  type: 'object',
  name: 'SubRamaEmpresarial',
  properties: {
    id: NativeFields.Int,
    codigo: NativeFields.Int,
    titulo: NativeFields.String,
    descripcion: NativeFields.String,
    incluye: NativeFields.String,
    excluye: NativeFields.String,
    rama_empresarial: RamaEmpresarialSchema,
  },
  returnType: 'object',
  description: '',
};

const TipoDeEmpresaSchema = {
  type: 'object',
  name: 'TipoDeEmpresa',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const TipoDeEstablecimientoSchema = {
  type: 'object',
  name: 'TipoDeEstablecimiento',
  properties: {
    id: NativeFields.Int,
    nombre: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const CiudadanoSchema = {
  type: 'object',
  name: 'Ciudadano',
  properties: {
    id: NativeFields.Int,
    clave_ciudadana: NativeFields.String,
    CURP: NativeFields.String,
    INE: NativeFields.String,
    RFC: NativeFields.String,
    fecha_nacimiento: NativeFields.Date,
    first_name: NativeFields.String,
    last_name: NativeFields.String,
    second_last_name: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const ModenaSchema = {
  type: 'object',
  name: 'Modena',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
    descripcion: NativeFields.String,
    simbolo: NativeFields.String,
    decimales: NativeFields.Int,
    porcentaje_de_variacion: NativeFields.Float,
    mostrar_en_pago: NativeFields.Boolean,
    calculable: NativeFields.Boolean,
  },
  returnType: 'object',
  description: '',
};

const TipoDeAplicacionSchema = {
  type: 'object',
  name: 'TipoDeAplicacion',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const TipoDeTarifaSchema = {
  type: 'object',
  name: 'TipoDeTarifa',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const CatalogoDeTarifaSchema = {
  type: 'object',
  name: 'CatalogoDeTarifa',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
    tipo_de_tarifa: TipoDeTarifaSchema,
  },
  returnType: 'object',
  description: '',
};

const NaturalezaDeIngresoSchema = {
  type: 'object',
  name: 'NaturalezaDeIngreso',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const NormatividadSchema = {
  type: 'object',
  name: 'Normatividad',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const FundamentoLegalSchema = {
  type: 'object',
  name: 'FundamentoLegal',
  properties: {
    id: NativeFields.Int,
    denominacion: NativeFields.String,
    articulo: NativeFields.String,
    fraccion: NativeFields.String,
    inciso: NativeFields.String,
    parrafo: NativeFields.String,
    numero: NativeFields.String,
    letra: NativeFields.String,
    hipervinculo: NativeFields.String,
    area_responsable: NativeFields.String,
    fecha_publicacion: NativeFields.Date,
    normatividad: NormatividadSchema,
  },
  returnType: 'object',
  description: '',
};

const FuenteSchema = {
  type: 'object',
  name: 'Fuente',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const ClasificadorEconomicoSchema = {
  type: 'object',
  name: 'ClasificadorEconomico',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const PeriodoFiscalSchema = {
  type: 'object',
  name: 'PeriodoFiscal',
  properties: {
    id: NativeFields.Int,
    periodo: NativeFields.Int,
    identificador: NativeFields.Int,
    fecha_inicial: NativeFields.Date,
    fecha_final: NativeFields.Date,
    fecha_autorizacion: NativeFields.Date,
    vigente: NativeFields.Boolean,
  },
  returnType: 'object',
  description: '',
};

const RubroSchema = {
  type: 'object',
  name: 'Rubro',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
    denominacion: NativeFields.String,
    nivel: NativeFields.Int,
  },
  returnType: 'object',
  description: '',
};

const TipoSchema = {
  type: 'object',
  name: 'Tipo',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
    denominacion: NativeFields.String,
    nivel: NativeFields.Int,
    rubro: RubroSchema,
  },
  returnType: 'object',
  description: '',
};

const ClaseSchema = {
  type: 'object',
  name: 'Clase',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
    denominacion: NativeFields.String,
    nivel: NativeFields.Int,
    recaudacion_presupuestada: NativeFields.Float,
    tipo: TipoSchema,
  },
  returnType: 'object',
  description: '',
};

const ConceptoDeIngresoSchema = {
  type: 'object',
  name: 'ConceptoDeIngreso',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
    descripcion: NativeFields.String,
    sub_cuenta_contable: NativeFields.Int,
    es_ingreso_presupuestal: NativeFields.Boolean,
    naturaleza_de_ingresos: NaturalezaDeIngresoSchema,
    fundamento_legal: FundamentoLegalSchema,
    fuente_de_ingreso: FuenteSchema,
    clasificador_economico: ClasificadorEconomicoSchema,
    periodo_fiscal: PeriodoFiscalSchema,
    padron: PadronSchema,
    canales_de_pago: [CanalDePagoSchema],
    cri_clase: ClaseSchema,
  },
  returnType: 'object',
  description: '',
};

const TipoDeDatoSchema = {
  type: 'object',
  name: 'TipoDeDato',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const AplicacionDelDescuentoSchema = {
  type: 'object',
  name: 'AplicacionDelDescuento',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const TipoDeDescuentoSchema = {
  type: 'object',
  name: 'TipoDeDescuento',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
    descripcion: NativeFields.String,
    observaciones: NativeFields.String,
    es_descuento_especial: NativeFields.Boolean,
    cantidad_minima: NativeFields.Int,
    cantidad_maxima: NativeFields.Int,
    dias_de_vigencia: NativeFields.Int,
    importe_minimo: NativeFields.Decimal,
    importe_maximo: NativeFields.Decimal,
    formula: NativeFields.String,
    el_descuento_es_por_rango_de_fechas: NativeFields.Boolean,
    fecha_inicio: NativeFields.DateTime,
    fecha_fin: NativeFields.DateTime,
    requiere_autorizacion: NativeFields.Boolean,
    tipo_de_aplicacion: TipoDeAplicacionSchema,
    canales_de_pago: [CanalDePagoSchema],
    padron: PadronSchema,
    catalogo_de_tarifa: CatalogoDeTarifaSchema,
    aplicacion_del_descuento: AplicacionDelDescuentoSchema,
  },
  returnType: 'object',
  description: '',
};

const TipoDeRecargoSchema = {
  type: 'object',
  name: 'TipoDeRecargo',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
    es_multa: NativeFields.Boolean,
    es_calculable_por_periodo: NativeFields.Boolean,
    dias_de_gracia: NativeFields.Int,
    fecha_de_vencimiento: NativeFields.Date,
    importe: NativeFields.Decimal,
    importe_minimo: NativeFields.Decimal,
    importe_maximo: NativeFields.Decimal,
    es_recargo_sobre_base: NativeFields.Boolean,
    porcentaje: NativeFields.Float,
    tipo_de_aplicacion: TipoDeAplicacionSchema,
    clase_cri: ClaseSchema,
    catalogo_de_tarifa: CatalogoDeTarifaSchema,
    periodo: PeriodoSchema,
    concepto_de_ingreso: ConceptoDeIngresoSchema,
    tipos_de_descuento: TipoDeDescuentoSchema,
  },
  returnType: 'object',
  description: '',
};

const TipoDeGastoSchema = {
  type: 'object',
  name: 'TipoDeGasto',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
    descripcion: NativeFields.String,
    observaciones: NativeFields.String,
    parametro_descripcion: NativeFields.String,
    formula: NativeFields.String,
    importe: NativeFields.Decimal,
    importe_total: NativeFields.Decimal,
    importe_minimo: NativeFields.Decimal,
    importe_maximo: NativeFields.Decimal,
    fecha_de_vencimiento: NativeFields.Date,
    identificador_periodo: NativeFields.Int,
    moneda: ModenaSchema,
    tipo_de_aplicacion: TipoDeAplicacionSchema,
    catalogo_de_tarifa: CatalogoDeTarifaSchema,
    concepto_de_ingreso: ConceptoDeIngresoSchema,
    periodo: PeriodoSchema,
    periodo_fiscal: PeriodoFiscalSchema,
    tipo_de_dato: TipoDeDatoSchema,
    tipos_de_descuento: TipoDeDescuentoSchema,
    padron: PadronSchema,
  },
  returnType: 'object',
  description: '',
};

const TipoDeActualizacionSchema = {
  type: 'object',
  name: 'TipoDeActualizacion',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
    descripcion: NativeFields.String,
    observaciones: NativeFields.String,
    dias_de_gracia: NativeFields.Int,
    fecha_de_vencimiento: NativeFields.Date,
    importe: NativeFields.Decimal,
    importe_minimo: NativeFields.Decimal,
    importe_maximo: NativeFields.Decimal,
    formula: NativeFields.String,
    porcentaje: NativeFields.Float,
    es_actualizacion_sobre_base: NativeFields.Boolean,
    concepto_de_ingreso: ConceptoDeIngresoSchema,
    tipo_de_aplicacion: TipoDeAplicacionSchema,
    clase_cri: ClaseSchema,
    catalogo_de_tarifa: CatalogoDeTarifaSchema,
    periodo: PeriodoSchema,
    tipos_de_descuento: [TipoDeDescuentoSchema],
  },
  returnType: 'object',
  description: '',
};

const AccesoriosSchema = {
  type: 'object',
  name: 'TipoDeCargo',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
    importe: NativeFields.String,
    importe_total: NativeFields.String,
    importe_minimo: NativeFields.String,
    importe_maximo: NativeFields.String,
    es_convenio: NativeFields.Boolean,
    es_cargo_unico: NativeFields.Boolean,
    fecha_de_vencimiento: NativeFields.Date,
    es_accesorio: NativeFields.Boolean,
    no_aplica_descuento: NativeFields.Boolean,
    es_cargo_no_requerible: NativeFields.Boolean,
    es_facturable: NativeFields.Boolean,
    es_responsabilidad: NativeFields.Boolean,
    identificador_periodo: NativeFields.Int,
    moneda: ModenaSchema,
    tipo_de_aplicacion: TipoDeAplicacionSchema,
    catalogo_de_tarifa: CatalogoDeTarifaSchema,
    concepto_de_ingreso: ConceptoDeIngresoSchema,
    periodo: PeriodoSchema,
    periodo_fiscal: PeriodoFiscalSchema,
    canales_de_pago: [CanalDePagoSchema],
    padron: PadronSchema,
  },
  returnType: 'object',
  description: '',
};

const TipoDeCargoSchema = {
  type: 'object',
  name: 'TipoDeCargo',
  properties: {
    id: NativeFields.Int,
    clave: NativeFields.String,
    importe: NativeFields.String,
    importe_total: NativeFields.String,
    importe_minimo: NativeFields.String,
    importe_maximo: NativeFields.String,
    es_convenio: NativeFields.Boolean,
    es_cargo_unico: NativeFields.Boolean,
    fecha_de_vencimiento: NativeFields.Date,
    es_accesorio: NativeFields.Boolean,
    no_aplica_descuento: NativeFields.Boolean,
    es_cargo_no_requerible: NativeFields.Boolean,
    es_facturable: NativeFields.Boolean,
    es_responsabilidad: NativeFields.Boolean,
    identificador_periodo: NativeFields.Int,
    moneda: ModenaSchema,
    tipo_de_aplicacion: TipoDeAplicacionSchema,
    catalogo_de_tarifa: CatalogoDeTarifaSchema,
    concepto_de_ingreso: ConceptoDeIngresoSchema,
    periodo: PeriodoSchema,
    periodo_fiscal: PeriodoFiscalSchema,
    tipo_de_dato: TipoDeDatoSchema,
    canales_de_pago: [CanalDePagoSchema],
    tipos_de_recargo: [TipoDeRecargoSchema],
    accesorios: [AccesoriosSchema],
    tipos_de_actualizacion: [TipoDeActualizacionSchema],
    tipos_de_descuento: [TipoDeDescuentoSchema],
    tipos_de_gasto: TipoDeGastoSchema,
    padron: PadronSchema,
  },
  returnType: 'object',
  description: '',
};

const CargoSchema = {
  type: 'object',
  name: 'Cargo',
  properties: {
    id: NativeFields.Int,
    importe: NativeFields.Decimal,
    descripcion: NativeFields.String,
    fecha_de_vencimiento: NativeFields.Date,
    saldado: NativeFields.Boolean,
    object_id: NativeFields.Int,
    content_type: ContentTypeSchema,
    tipo_de_cargo: TipoDeCargoSchema,
  },
  returnType: 'object',
  description: '',
};

const PredioSchema = {
  type: 'object',
  name: 'Predio',
  properties: {
    id: NativeFields.Int,
    cuenta_unica_de_predial: NativeFields.String,
    descripcion: NativeFields.String,
    valor_catastral: NativeFields.Decimal,
    CURT: NativeFields.String,
    clave_catastral_estandar: NativeFields.String,
    clave_catastral_municipal: NativeFields.String,
    clave_sectorial: NativeFields.String,
    uso_de_predio: UsoDePredioSchema,
    regimen_de_propiedad: RegimenDePropiedadSchema,
    porcentaje_del_condominio: NativeFields.Float,
    terreno_del_predio: TerrenoDelPredioSchema,
    factores_especiales: FactoresEspecialesSchema,
    construccion_del_predio: ConstruccionSchema,
    calculo_de_valor: CalculoDeValorSchema,
    valor_del_ultimo_impuesto_predial: CargoSchema,
    ciudadano: CiudadanoSchema,
  },
  returnType: 'object',
  description: '',
};

const SucursalDeEmpresaSchema = {
  type: 'object',
  name: 'SucursalDeEmpresa',
  properties: {
    id: NativeFields.Int,
    numero_de_la_sucursal: NativeFields.Int,
    nombre_de_la_sucursal: NativeFields.String,
    predio: PredioSchema,
    tipo_de_suelo: TipoDeSueloSchema,
  },
  returnType: 'object',
  description: '',
};

const EstadoDeNegocioSchema = {
  type: 'object',
  name: 'EstadoDeNegocio',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const ClasificacionDeComercioSchema = {
  type: 'object',
  name: 'ClasificacionDeComercio',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const CatalogoDeDiasSchema = {
  type: 'object',
  name: 'CatalogoDeDias',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const HorarioSchema = {
  type: 'object',
  name: 'Horario',
  properties: {
    id: NativeFields.Int,
    entrada: NativeFields.Time,
    salida: NativeFields.Time,
    horario_de_entidad: NativeFields.Boolean,
    dias_laborales: [CatalogoDeDiasSchema],
    dias_de_descanso: [CatalogoDeDiasSchema],
  },
  returnType: 'object',
  description: '',
};

const EmpresaSchema = {
  type: 'object',
  name: 'Empresa',
  properties: {
    id: NativeFields.Int,
    clave_municipal: NativeFields.String,
    razon_social: NativeFields.String,
    nombre_comercial: NativeFields.String,
    es_persona_fisica: NativeFields.Boolean,
    RFC: NativeFields.String,
    superficie_del_terreno: NativeFields.Decimal,
    superficie_construida_del_terreno: NativeFields.Decimal,
    numero_de_telefono: NativeFields.Int,
    sitio_de_internet: NativeFields.String,
    licencia_sanitaria: NativeFields.String,
    licencia_ecologica: NativeFields.String,
    registro_patronal_IMSS: NativeFields.String,
    numero_de_empleados: NativeFields.Int,
    ocupacion_maxima_de_empleados: NativeFields.Int,
    fecha_de_alta_de_padron: NativeFields.Date,
    fecha_de_apertura: NativeFields.Date,
    alta_SHCP: NativeFields.String,
    cajones_de_estacionamiento: NativeFields.Int,
    zona_de_carga_descarga: NativeFields.Decimal,
    observaciones: NativeFields.String,
    horarios: [HorarioSchema],
    tipo_de_establecimiento: TipoDeEstablecimientoSchema,
    predio: PredioSchema,
    padron: PadronSchema,
    regimen_de_empresa: RegimenDePropiedadSchema,
    estado_de_negocio: EstadoDeNegocioSchema,
    clasificacion_de_comercio: ClasificacionDeComercioSchema,
    sector_empresarial: SectorEmpresarialSchema,
    sucursal: SucursalDeEmpresaSchema,
    representantes: [CiudadanoSchema],
    tipo_empresa: TipoDeEmpresaSchema,
  },
  returnType: 'object',
  description: '',
};

const AnuncioSchema = {
  type: 'object',
  name: 'Anuncio',
  properties: {
    id: NativeFields.Int,
    es_luminoso: NativeFields.Boolean,
    medida_total: NativeFields.Decimal,
    sucursal: SucursalDeEmpresaSchema,
    empresa: EmpresaSchema,
  },
  returnType: 'object',
  description: '',
};

const TipoDeCentroYPlazaSchema = {
  type: 'object',
  name: 'TipoDeCentroYPlaza',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const CatalogoDelEstadoDelTramiteSchema = {
  type: 'object',
  name: 'CatalogoDelEstadoDelTramite',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const FactibilidadSchema = {
  type: 'object',
  name: 'Factibilidad',
  properties: {
    id: NativeFields.Int,
    clave_catastral: NativeFields.String,
    superficie: NativeFields.Float,
    cuenta_predial: NativeFields.Decimal,
    empresa: EmpresaSchema,
    ultimo_adeudo_predial: PredioSchema,
  },
  returnType: 'object',
  description: '',
};

const TipoDeLicenciaSchemaSchema = {
  type: 'object',
  name: 'TipoDeLicenciaSchema',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const LicenciaDeFuncionamientoSchema = {
  type: 'object',
  name: 'LicenciaDeFuncionamiento',
  properties: {
    id: NativeFields.Int,
    folio: NativeFields.String,
    fecha_de_inicio: NativeFields.Date,
    fecha_de_finalizacion: NativeFields.Date,
    estado_de_la_licencia: NativeFields.Boolean,
    folio_del_recibo: NativeFields.String,
    inspeccion: NativeFields.Boolean,
    dictament_factibilidad: NativeFields.Boolean,
    dictamen_licencia: NativeFields.Boolean,
    archivos_adjuntos: NativeFields.String,
    estado_del_tramite: CatalogoDelEstadoDelTramiteSchema,
    factibilidad: FactibilidadSchema,
    tipo_de_licencia: TipoDeLicenciaSchemaSchema,
    notificacion: PredioSchema,
  },
  returnType: 'object',
  description: '',
};

const CentroYPlazaSchema = {
  type: 'object',
  name: 'CentroYPlaza',
  properties: {
    id: NativeFields.Int,
    descripcion: NativeFields.String,
    numero_de_locales: NativeFields.Int,
    numero_de_locales_disponibles: NativeFields.Int,
    tipo_de_centro_y_plaza: TipoDeCentroYPlazaSchema,
    predio: PredioSchema,
    licencia_de_funcionamiento: LicenciaDeFuncionamientoSchema,
  },
  returnType: 'object',
  description: '',
};

const RegimenDeEmpresaSchema = {
  type: 'object',
  name: 'RegimenDeEmpresa',
  properties: {
    id: NativeFields.Int,
    codigo_regimen_fiscal: NativeFields.Int,
    descripcion: NativeFields.String,
    persona_fisica: NativeFields.Boolean,
    persona_moral: NativeFields.Boolean,
    fecha_de_inicio_de_vigencia: NativeFields.Date,
    fecha_de_fin_de_vigencia: NativeFields.Date,
  },
  returnType: 'object',
  description: '',
};

const EmpresaFiscalSchema = {
  type: 'object',
  name: 'EmpresaFiscal',
  properties: {
    id: NativeFields.Int,
    razon_social: NativeFields.String,
    es_persona_fisica: NativeFields.Boolean,
    empresa: EmpresaSchema,
    regimen_de_empresa: RegimenDeEmpresaSchema,
  },
  returnType: 'object',
  description: '',
};

const GiroDeEntidadSchema = {
  type: 'object',
  name: 'GiroDeEntidad',
  properties: {
    id: NativeFields.Int,
    nombre: NativeFields.String,
    comentario: NativeFields.String,
    es_de_bajo_riesgo: NativeFields.Boolean,
    licencia_sanitaria: NativeFields.Int,
    licencia_ecologica: NativeFields.Int,
    abreviacion: NativeFields.String,
    clave: NativeFields.String,
    sector_empresarial: SectorEmpresarialSchema,
  },
  returnType: 'object',
  description: '',
};

const ClaseDelVehiculoSchema = {
  type: 'object',
  name: 'ClaseDelVehiculo',
  properties: {
    id: NativeFields.Int,
    nombre: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const TipoDeVehiculoSchema = {
  type: 'object',
  name: 'TipoDeVehiculo',
  properties: {
    id: NativeFields.Int,
    nombre: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const MarcaDelVehiculoSchema = {
  type: 'object',
  name: 'MarcaDelVehiculo',
  properties: {
    id: NativeFields.Int,
    nombre: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const LineaVehicularSchema = {
  type: 'object',
  name: 'LineaVehicular',
  properties: {
    id: NativeFields.Int,
    nombre: NativeFields.String,
    marca: MarcaDelVehiculoSchema,
  },
  returnType: 'object',
  description: '',
};

const EstadoDelVehiculoSchema = {
  type: 'object',
  name: 'EstadoDelVehiculo',
  properties: {
    id: NativeFields.Int,
    nombre: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const ServicioDelVehiculoSchema = {
  type: 'object',
  name: 'ServicioDelVehiculo',
  properties: {
    id: NativeFields.Int,
    nombre: NativeFields.String,
  },
  returnType: 'object',
  description: '',
};

const VehiculoSchema = {
  type: 'object',
  name: 'Vehiculo',
  properties: {
    id: NativeFields.Int,
    numero_de_placa: NativeFields.String,
    serie: NativeFields.String,
    modelo_del_vehiculo: NativeFields.Int,
    tarjeta_de_circulacion: NativeFields.String,
    clave_vehicular: NativeFields.Int,
    capacidad: NativeFields.Int,
    registro_publico_vehicular: NativeFields.String,
    verificacion_tecnica_vehicular: NativeFields.String,
    servicio: ServicioDelVehiculoSchema,
    estatus_del_vehiculo: EstadoDelVehiculoSchema,
    linea: LineaVehicularSchema,
    tipo_de_vehiculo: TipoDeVehiculoSchema,
    clase_del_vehiculo: ClaseDelVehiculoSchema,
    propietario: CiudadanoSchema,
  },
  returnType: 'object',
  description: '',
};

// Querysets
const BandasDeValor = {
  type: 'queryset',
  name: 'BandasDeValor',
  modelSchema: BandaDeValorSchema,
  methods: {
    filter: {
      argumens: BandaDeValorSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: BandaDeValorSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: BandaDeValorSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const CategoriasDePredio = {
  type: 'queryset',
  name: 'CategoriasDePredio',
  modelSchema: CategoriaDePredioSchema,
  methods: {
    filter: {
      argumens: CategoriaDePredioSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: CategoriaDePredioSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: CategoriaDePredioSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const CategoriasDeRechazo = {
  type: 'queryset',
  name: 'CategoriasDeRechazo',
  modelSchema: CategoriaDeRechazoSchema,
  methods: {
    filter: {
      argumens: CategoriaDeRechazoSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: CategoriaDeRechazoSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: CategoriaDeRechazoSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const TiposDeDominio = {
  type: 'queryset',
  name: 'TiposDeDominio',
  modelSchema: TipoDeDominioSchema,
  methods: {
    filter: {
      argumens: TipoDeDominioSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: TipoDeDominioSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: TipoDeDominioSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const TiposDeSuelo = {
  type: 'queryset',
  name: 'TiposDeSuelo',
  modelSchema: TipoDeSueloSchema,
  methods: {
    filter: {
      argumens: TipoDeSueloSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: TipoDeSueloSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: TipoDeSueloSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const RegimenesDePropiedad = {
  type: 'queryset',
  name: 'RegimenesDePropiedad',
  modelSchema: RegimenDePropiedadSchema,
  methods: {
    filter: {
      argumens: RegimenDePropiedadSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: RegimenDePropiedadSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: RegimenDePropiedadSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const UsosDePredio = {
  type: 'queryset',
  name: 'UsosDePredio',
  modelSchema: UsoDePredioSchema,
  methods: {
    filter: {
      argumens: UsoDePredioSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: UsoDePredioSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: UsoDePredioSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const CalculosDeValor = {
  type: 'queryset',
  name: 'CalculosDeValor',
  modelSchema: CalculoDeValorSchema,
  methods: {
    filter: {
      argumens: CalculoDeValorSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: CalculoDeValorSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: CalculoDeValorSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const CalidadesDeConstruccion = {
  type: 'queryset',
  name: 'CalidadesDeConstruccion',
  modelSchema: CalidadDeLaConstruccionSchema,
  methods: {
    filter: {
      argumens: CalidadDeLaConstruccionSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: CalidadDeLaConstruccionSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: CalidadDeLaConstruccionSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const ClasificacionesDeConstruccion = {
  type: 'queryset',
  name: 'ClasificacionesDeConstruccion',
  modelSchema: ClasificacionDeLaConstruccionSchema,
  methods: {
    filter: {
      argumens: ClasificacionDeLaConstruccionSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: ClasificacionDeLaConstruccionSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: ClasificacionDeLaConstruccionSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const Construcciones = {
  type: 'queryset',
  name: 'Construcciones',
  modelSchema: ConstruccionSchema,
  methods: {
    filter: {
      argumens: ConstruccionSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: ConstruccionSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: ConstruccionSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const EstadosDeConstruccion = {
  type: 'queryset',
  name: 'EstadosDeConstruccion',
  modelSchema: EstadoDeLaConstruccionSchema,
  methods: {
    filter: {
      argumens: EstadoDeLaConstruccionSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: EstadoDeLaConstruccionSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: EstadoDeLaConstruccionSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const FactoresEspeciales = {
  type: 'queryset',
  name: 'FactoresEspeciales',
  modelSchema: FactoresEspecialesSchema,
  methods: {
    filter: {
      argumens: FactoresEspecialesSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: FactoresEspecialesSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: FactoresEspecialesSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const MeritosYDemeritos = {
  type: 'queryset',
  name: 'MeritosYDemeritos',
  modelSchema: MeritoYDemeritoSchema,
  methods: {
    filter: {
      argumens: MeritoYDemeritoSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: MeritoYDemeritoSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: MeritoYDemeritoSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const Participes = {
  type: 'queryset',
  name: 'Participes',
  modelSchema: ParticipeSchema,
  methods: {
    filter: {
      argumens: ParticipeSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: ParticipeSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: ParticipeSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const TasasDAPRural = {
  type: 'queryset',
  name: 'TasasDAPRural',
  modelSchema: TasaDAPRuralSchema,
  methods: {
    filter: {
      argumens: TasaDAPRuralSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: TasaDAPRuralSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: TasaDAPRuralSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const TasasDAPUrbano = {
  type: 'queryset',
  name: 'TasasDAPUrbano',
  modelSchema: TasaDAPUrbanoSchema,
  methods: {
    filter: {
      argumens: TasaDAPUrbanoSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: TasaDAPUrbanoSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: TasaDAPUrbanoSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const TasasDeConstruccionDePredioUrbano = {
  type: 'queryset',
  name: 'TasasDeConstruccionDePredioUrbano',
  modelSchema: TasaDeConstruccionDePredioUrbanoSchema,
  methods: {
    filter: {
      argumens: TasaDeConstruccionDePredioUrbanoSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: TasaDeConstruccionDePredioUrbanoSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: TasaDeConstruccionDePredioUrbanoSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const TasasDeConstruccionDePredioRural = {
  type: 'queryset',
  name: 'TasasDeConstruccionDePredioRural',
  modelSchema: TasaDeConstruccionDePredioRuralSchema,
  methods: {
    filter: {
      argumens: TasaDeConstruccionDePredioRuralSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: TasaDeConstruccionDePredioRuralSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: TasaDeConstruccionDePredioRuralSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const TasasDePredioRural = {
  type: 'queryset',
  name: 'TasasDePredioRural',
  modelSchema: TasaDePredioRuralSchema,
  methods: {
    filter: {
      argumens: TasaDePredioRuralSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: TasaDePredioRuralSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: TasaDePredioRuralSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const TasasDePredioUrbano = {
  type: 'queryset',
  name: 'TasasDePredioUrbano',
  modelSchema: TasaDePredioUrbanoSchema,
  methods: {
    filter: {
      argumens: TasaDePredioUrbanoSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: TasaDePredioUrbanoSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: TasaDePredioUrbanoSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const TerrenosDePredio = {
  type: 'queryset',
  name: 'TerrenosDePredio',
  modelSchema: TerrenoDelPredioSchema,
  methods: {
    filter: {
      argumens: TerrenoDelPredioSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: TerrenoDelPredioSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: TerrenoDelPredioSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const TiposDeConstruccion = {
  type: 'queryset',
  name: 'TiposDeConstruccion',
  modelSchema: TipoDeLaConstruccionSchema,
  methods: {
    filter: {
      argumens: TipoDeLaConstruccionSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: TipoDeLaConstruccionSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: TipoDeLaConstruccionSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const ZonasHomogeneas = {
  type: 'queryset',
  name: 'ZonasHomogeneas',
  modelSchema: ZonaHomogeneaSchema,
  methods: {
    filter: {
      argumens: ZonaHomogeneaSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: ZonaHomogeneaSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: ZonaHomogeneaSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const CatalogoDeValor = {
  type: 'queryset',
  name: 'CatalogoDeValor',
  modelSchema: CatalogoDeValorSchema,
  methods: {
    filter: {
      argumens: CatalogoDeValorSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: CatalogoDeValorSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: CatalogoDeValorSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const UMA = {
  type: 'queryset',
  name: 'UMA',
  modelSchema: UMASchema,
  methods: {
    filter: {
      argumens: UMASchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: UMASchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: UMASchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const CPP = {
  type: 'queryset',
  name: 'CPP',
  modelSchema: CPPSchema,
  methods: {
    filter: {
      argumens: CPPSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: CPPSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: CPPSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const INPC = {
  type: 'queryset',
  name: 'INPC',
  modelSchema: INPCSchema,
  methods: {
    filter: {
      argumens: INPCSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: INPCSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: INPCSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const SalariosMinimos = {
  type: 'queryset',
  name: 'SalariosMinimos',
  modelSchema: SalarioMinimoSchema,
  methods: {
    filter: {
      argumens: SalarioMinimoSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: SalarioMinimoSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: SalarioMinimoSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const CanalesDePago = {
  type: 'queryset',
  name: 'CanalesDePago',
  modelSchema: CanalDePagoSchema,
  methods: {
    filter: {
      argumens: CanalDePagoSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: CanalDePagoSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: CanalDePagoSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const SectoresEmpresarial = {
  type: 'queryset',
  name: 'SectoresEmpresarial',
  modelSchema: SectorEmpresarialSchema,
  methods: {
    filter: {
      argumens: SectorEmpresarialSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: SectorEmpresarialSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: SectorEmpresarialSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const SubRamasEmpresariales = {
  type: 'queryset',
  name: 'SubRamasEmpresariales',
  modelSchema: SubRamaEmpresarialSchema,
  methods: {
    filter: {
      argumens: SubRamaEmpresarialSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: SubRamaEmpresarialSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: SubRamaEmpresarialSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const SubSectoresEmpresariales = {
  type: 'queryset',
  name: 'SubSectoresEmpresariales',
  modelSchema: SubSectorEmpresarialSchema,
  methods: {
    filter: {
      argumens: SubSectorEmpresarialSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: SubSectorEmpresarialSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: SubSectorEmpresarialSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const TiposDeEmpresas = {
  type: 'queryset',
  name: 'TiposDeEmpresas',
  modelSchema: TipoDeEmpresaSchema,
  methods: {
    filter: {
      argumens: TipoDeEmpresaSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: TipoDeEmpresaSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: TipoDeEmpresaSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const TiposDeEstablecimiento = {
  type: 'queryset',
  name: 'TiposDeEstablecimiento',
  modelSchema: TipoDeEstablecimientoSchema,
  methods: {
    filter: {
      argumens: TipoDeEstablecimientoSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: TipoDeEstablecimientoSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: TipoDeEstablecimientoSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const Anuncios = {
  type: 'queryset',
  name: 'Anuncios',
  modelSchema: AnuncioSchema,
  methods: {
    filter: {
      argumens: AnuncioSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: AnuncioSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: AnuncioSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const CentrosYPlazas = {
  type: 'queryset',
  name: 'CentrosYPlazas',
  modelSchema: CentroYPlazaSchema,
  methods: {
    filter: {
      argumens: CentroYPlazaSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: CentroYPlazaSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: CentroYPlazaSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const EmpresasFiscales = {
  type: 'queryset',
  name: 'EmpresasFiscales',
  modelSchema: EmpresaFiscalSchema,
  methods: {
    filter: {
      argumens: EmpresaFiscalSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: EmpresaFiscalSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: EmpresaFiscalSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const GirosDeEntidad = {
  type: 'queryset',
  name: 'GirosDeEntidad',
  modelSchema: GiroDeEntidadSchema,
  methods: {
    filter: {
      argumens: GiroDeEntidadSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: GiroDeEntidadSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: GiroDeEntidadSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const SucursalesDeEmpresas = {
  type: 'queryset',
  name: 'SucursalesDeEmpresas',
  modelSchema: SucursalDeEmpresaSchema,
  methods: {
    filter: {
      argumens: SucursalDeEmpresaSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: SucursalDeEmpresaSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: SucursalDeEmpresaSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const TiposDeCentrosYPlazas = {
  type: 'queryset',
  name: 'TiposDeCentrosYPlazas',
  modelSchema: TipoDeCentroYPlazaSchema,
  methods: {
    filter: {
      argumens: TipoDeCentroYPlazaSchema.properties,
      returnType: 'self',
      description: '',
    },
    exclude: {
      argumens: TipoDeCentroYPlazaSchema.properties,
      returnType: 'self',
      description: '',
    },
    annotate: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    order_by: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    reverse: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    distinct: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values: {
      argumens: {
        '*args': {},
      },
      returnType: 'self',
      description: '',
    },
    values_list: {
      argumens: {},
      returnType: 'list',
      description: '',
    },
    all: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    first: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    last: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    only: {
      argumens: {},
      returnType: 'self',
      description: '',
    },
    get: {
      argumens: TipoDeCentroYPlazaSchema.properties,
      returnType: 'modelSchema',
      description: '',
    },
    count: {
      argumens: {},
      returnType: NativeFields.Int,
      description: '',
    },
    latest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    earliest: {
      argumens: {},
      returnType: 'modelSchema',
      description: '',
    },
    exists: {
      argumens: {},
      returnType: NativeFields.Boolean,
      description: '',
    },
  },
  properties: {},
  returnType: 'queryset',
};

const TodoSchema = {
  type: 'object',
  name: 'Todo',
  properties: {
    id: NativeFields.Int,
    clave_municipal: NativeFields.String,
    razon_social: NativeFields.String,
    nombre_comercial: NativeFields.String,
    es_persona_fisica: NativeFields.Boolean,
    RFC: NativeFields.String,
    superficie_del_terreno: NativeFields.Decimal,
    superficie_construida_del_terreno: NativeFields.Decimal,
    numero_de_telefono: NativeFields.Int,
    sitio_de_internet: NativeFields.String,
    licencia_sanitaria: NativeFields.String,
    licencia_ecologica: NativeFields.String,
    registro_patronal_IMSS: NativeFields.String,
    numero_de_empleados: NativeFields.Int,
    ocupacion_maxima_de_empleados: NativeFields.Int,
    fecha_de_alta_de_padron: NativeFields.Date,
    fecha_de_apertura: NativeFields.Date,
    alta_SHCP: NativeFields.String,
    cajones_de_estacionamiento: NativeFields.Int,
    zona_de_carga_descarga: NativeFields.Decimal,
    observaciones: NativeFields.String,
    horarios: [HorarioSchema],
    tipo_de_establecimiento: TipoDeEstablecimientoSchema,
    predio: PredioSchema,
    padron: PadronSchema,
    regimen_de_empresa: RegimenDePropiedadSchema,
    estado_de_negocio: EstadoDeNegocioSchema,
    clasificacion_de_comercio: ClasificacionDeComercioSchema,
    sector_empresarial: SectorEmpresarialSchema,
    sucursal: SucursalDeEmpresaSchema,
    representantes: [CiudadanoSchema],
    tipo_empresa: TipoDeEmpresaSchema,
  },
  returnType: 'object',
  description: '',
};

const HospedajeSchema = {
  type: 'object',
  name: 'Hospedaje',
  properties: {
    id: NativeFields.Int,
    clave_municipal: NativeFields.String,
    razon_social: NativeFields.String,
    nombre_comercial: NativeFields.String,
    es_persona_fisica: NativeFields.Boolean,
    RFC: NativeFields.String,
    superficie_del_terreno: NativeFields.Decimal,
    superficie_construida_del_terreno: NativeFields.Decimal,
    numero_de_telefono: NativeFields.Int,
    sitio_de_internet: NativeFields.String,
    licencia_sanitaria: NativeFields.String,
    licencia_ecologica: NativeFields.String,
    registro_patronal_IMSS: NativeFields.String,
    numero_de_empleados: NativeFields.Int,
    ocupacion_maxima_de_empleados: NativeFields.Int,
    fecha_de_alta_de_padron: NativeFields.Date,
    fecha_de_apertura: NativeFields.Date,
    alta_SHCP: NativeFields.String,
    cajones_de_estacionamiento: NativeFields.Int,
    zona_de_carga_descarga: NativeFields.Decimal,
    observaciones: NativeFields.String,
    horarios: [HorarioSchema],
    tipo_de_establecimiento: TipoDeEstablecimientoSchema,
    predio: PredioSchema,
    padron: PadronSchema,
    regimen_de_empresa: RegimenDePropiedadSchema,
    estado_de_negocio: EstadoDeNegocioSchema,
    clasificacion_de_comercio: ClasificacionDeComercioSchema,
    sector_empresarial: SectorEmpresarialSchema,
    sucursal: SucursalDeEmpresaSchema,
    representantes: [CiudadanoSchema],
    tipo_empresa: TipoDeEmpresaSchema,
  },
  returnType: 'object',
  description: '',
};

const ArrendamientoSchema = {
  type: 'object',
  name: 'Arrendamiento',
  properties: {
    id: NativeFields.Int,
    clave_municipal: NativeFields.String,
    razon_social: NativeFields.String,
    nombre_comercial: NativeFields.String,
    es_persona_fisica: NativeFields.Boolean,
    RFC: NativeFields.String,
    superficie_del_terreno: NativeFields.Decimal,
    superficie_construida_del_terreno: NativeFields.Decimal,
    numero_de_telefono: NativeFields.Int,
    sitio_de_internet: NativeFields.String,
    licencia_sanitaria: NativeFields.String,
    licencia_ecologica: NativeFields.String,
    registro_patronal_IMSS: NativeFields.String,
    numero_de_empleados: NativeFields.Int,
    ocupacion_maxima_de_empleados: NativeFields.Int,
    fecha_de_alta_de_padron: NativeFields.Date,
    fecha_de_apertura: NativeFields.Date,
    alta_SHCP: NativeFields.String,
    cajones_de_estacionamiento: NativeFields.Int,
    zona_de_carga_descarga: NativeFields.Decimal,
    observaciones: NativeFields.String,
    horarios: [HorarioSchema],
    tipo_de_establecimiento: TipoDeEstablecimientoSchema,
    predio: PredioSchema,
    padron: PadronSchema,
    regimen_de_empresa: RegimenDePropiedadSchema,
    estado_de_negocio: EstadoDeNegocioSchema,
    clasificacion_de_comercio: ClasificacionDeComercioSchema,
    sector_empresarial: SectorEmpresarialSchema,
    sucursal: SucursalDeEmpresaSchema,
    representantes: [CiudadanoSchema],
    tipo_empresa: TipoDeEmpresaSchema,
  },
  returnType: 'object',
  description: '',
};

const NominaSchema = {
  type: 'object',
  name: 'Nomina',
  properties: {
    id: NativeFields.Int,
    clave_municipal: NativeFields.String,
    razon_social: NativeFields.String,
    nombre_comercial: NativeFields.String,
    es_persona_fisica: NativeFields.Boolean,
    RFC: NativeFields.String,
    superficie_del_terreno: NativeFields.Decimal,
    superficie_construida_del_terreno: NativeFields.Decimal,
    numero_de_telefono: NativeFields.Int,
    sitio_de_internet: NativeFields.String,
    licencia_sanitaria: NativeFields.String,
    licencia_ecologica: NativeFields.String,
    registro_patronal_IMSS: NativeFields.String,
    numero_de_empleados: NativeFields.Int,
    ocupacion_maxima_de_empleados: NativeFields.Int,
    fecha_de_alta_de_padron: NativeFields.Date,
    fecha_de_apertura: NativeFields.Date,
    alta_SHCP: NativeFields.String,
    cajones_de_estacionamiento: NativeFields.Int,
    zona_de_carga_descarga: NativeFields.Decimal,
    observaciones: NativeFields.String,
    horarios: [HorarioSchema],
    tipo_de_establecimiento: TipoDeEstablecimientoSchema,
    predio: PredioSchema,
    padron: PadronSchema,
    regimen_de_empresa: RegimenDePropiedadSchema,
    estado_de_negocio: EstadoDeNegocioSchema,
    clasificacion_de_comercio: ClasificacionDeComercioSchema,
    sector_empresarial: SectorEmpresarialSchema,
    sucursal: SucursalDeEmpresaSchema,
    representantes: [CiudadanoSchema],
    tipo_empresa: TipoDeEmpresaSchema,
  },
  returnType: 'object',
  description: '',
};

const AlcoholSchema = {
  type: 'object',
  name: 'Alcohol',
  properties: {
    id: NativeFields.Int,
    clave_municipal: NativeFields.String,
    razon_social: NativeFields.String,
    nombre_comercial: NativeFields.String,
    es_persona_fisica: NativeFields.Boolean,
    RFC: NativeFields.String,
    superficie_del_terreno: NativeFields.Decimal,
    superficie_construida_del_terreno: NativeFields.Decimal,
    numero_de_telefono: NativeFields.Int,
    sitio_de_internet: NativeFields.String,
    licencia_sanitaria: NativeFields.String,
    licencia_ecologica: NativeFields.String,
    registro_patronal_IMSS: NativeFields.String,
    numero_de_empleados: NativeFields.Int,
    ocupacion_maxima_de_empleados: NativeFields.Int,
    fecha_de_alta_de_padron: NativeFields.Date,
    fecha_de_apertura: NativeFields.Date,
    alta_SHCP: NativeFields.String,
    cajones_de_estacionamiento: NativeFields.Int,
    zona_de_carga_descarga: NativeFields.Decimal,
    observaciones: NativeFields.String,
    horarios: [HorarioSchema],
    tipo_de_establecimiento: TipoDeEstablecimientoSchema,
    predio: PredioSchema,
    padron: PadronSchema,
    regimen_de_empresa: RegimenDePropiedadSchema,
    estado_de_negocio: EstadoDeNegocioSchema,
    clasificacion_de_comercio: ClasificacionDeComercioSchema,
    sector_empresarial: SectorEmpresarialSchema,
    sucursal: SucursalDeEmpresaSchema,
    representantes: [CiudadanoSchema],
    tipo_empresa: TipoDeEmpresaSchema,
  },
  returnType: 'object',
  description: '',
};

const CasaDeEmpenioSchema = {
  type: 'object',
  name: 'CasaDeEmpenio',
  properties: {
    id: NativeFields.Int,
    clave_municipal: NativeFields.String,
    razon_social: NativeFields.String,
    nombre_comercial: NativeFields.String,
    es_persona_fisica: NativeFields.Boolean,
    RFC: NativeFields.String,
    superficie_del_terreno: NativeFields.Decimal,
    superficie_construida_del_terreno: NativeFields.Decimal,
    numero_de_telefono: NativeFields.Int,
    sitio_de_internet: NativeFields.String,
    licencia_sanitaria: NativeFields.String,
    licencia_ecologica: NativeFields.String,
    registro_patronal_IMSS: NativeFields.String,
    numero_de_empleados: NativeFields.Int,
    ocupacion_maxima_de_empleados: NativeFields.Int,
    fecha_de_alta_de_padron: NativeFields.Date,
    fecha_de_apertura: NativeFields.Date,
    alta_SHCP: NativeFields.String,
    cajones_de_estacionamiento: NativeFields.Int,
    zona_de_carga_descarga: NativeFields.Decimal,
    observaciones: NativeFields.String,
    horarios: [HorarioSchema],
    tipo_de_establecimiento: TipoDeEstablecimientoSchema,
    predio: PredioSchema,
    padron: PadronSchema,
    regimen_de_empresa: RegimenDePropiedadSchema,
    estado_de_negocio: EstadoDeNegocioSchema,
    clasificacion_de_comercio: ClasificacionDeComercioSchema,
    sector_empresarial: SectorEmpresarialSchema,
    sucursal: SucursalDeEmpresaSchema,
    representantes: [CiudadanoSchema],
    tipo_empresa: TipoDeEmpresaSchema,
  },
  returnType: 'object',
  description: '',
};

const AgenciaSchema = {
  type: 'object',
  name: 'Agencia',
  properties: {
    id: NativeFields.Int,
    clave_municipal: NativeFields.String,
    razon_social: NativeFields.String,
    nombre_comercial: NativeFields.String,
    es_persona_fisica: NativeFields.Boolean,
    RFC: NativeFields.String,
    superficie_del_terreno: NativeFields.Decimal,
    superficie_construida_del_terreno: NativeFields.Decimal,
    numero_de_telefono: NativeFields.Int,
    sitio_de_internet: NativeFields.String,
    licencia_sanitaria: NativeFields.String,
    licencia_ecologica: NativeFields.String,
    registro_patronal_IMSS: NativeFields.String,
    numero_de_empleados: NativeFields.Int,
    ocupacion_maxima_de_empleados: NativeFields.Int,
    fecha_de_alta_de_padron: NativeFields.Date,
    fecha_de_apertura: NativeFields.Date,
    alta_SHCP: NativeFields.String,
    cajones_de_estacionamiento: NativeFields.Int,
    zona_de_carga_descarga: NativeFields.Decimal,
    observaciones: NativeFields.String,
    horarios: [HorarioSchema],
    tipo_de_establecimiento: TipoDeEstablecimientoSchema,
    predio: PredioSchema,
    padron: PadronSchema,
    regimen_de_empresa: RegimenDePropiedadSchema,
    estado_de_negocio: EstadoDeNegocioSchema,
    clasificacion_de_comercio: ClasificacionDeComercioSchema,
    sector_empresarial: SectorEmpresarialSchema,
    sucursal: SucursalDeEmpresaSchema,
    representantes: [CiudadanoSchema],
    tipo_empresa: TipoDeEmpresaSchema,
  },
  returnType: 'object',
  description: '',
};

const CedularSchema = {
  type: 'object',
  name: 'Cedular',
  properties: {
    id: NativeFields.Int,
    clave_municipal: NativeFields.String,
    razon_social: NativeFields.String,
    nombre_comercial: NativeFields.String,
    es_persona_fisica: NativeFields.Boolean,
    RFC: NativeFields.String,
    superficie_del_terreno: NativeFields.Decimal,
    superficie_construida_del_terreno: NativeFields.Decimal,
    numero_de_telefono: NativeFields.Int,
    sitio_de_internet: NativeFields.String,
    licencia_sanitaria: NativeFields.String,
    licencia_ecologica: NativeFields.String,
    registro_patronal_IMSS: NativeFields.String,
    numero_de_empleados: NativeFields.Int,
    ocupacion_maxima_de_empleados: NativeFields.Int,
    fecha_de_alta_de_padron: NativeFields.Date,
    fecha_de_apertura: NativeFields.Date,
    alta_SHCP: NativeFields.String,
    cajones_de_estacionamiento: NativeFields.Int,
    zona_de_carga_descarga: NativeFields.Decimal,
    observaciones: NativeFields.String,
    horarios: [HorarioSchema],
    tipo_de_establecimiento: TipoDeEstablecimientoSchema,
    predio: PredioSchema,
    padron: PadronSchema,
    regimen_de_empresa: RegimenDePropiedadSchema,
    estado_de_negocio: EstadoDeNegocioSchema,
    clasificacion_de_comercio: ClasificacionDeComercioSchema,
    sector_empresarial: SectorEmpresarialSchema,
    sucursal: SucursalDeEmpresaSchema,
    representantes: [CiudadanoSchema],
    tipo_empresa: TipoDeEmpresaSchema,
  },
  returnType: 'object',
  description: '',
};

const NotarioSchema = {
  type: 'object',
  name: 'Notario',
  properties: {
    id: NativeFields.Int,
    clave_municipal: NativeFields.String,
    razon_social: NativeFields.String,
    nombre_comercial: NativeFields.String,
    es_persona_fisica: NativeFields.Boolean,
    RFC: NativeFields.String,
    superficie_del_terreno: NativeFields.Decimal,
    superficie_construida_del_terreno: NativeFields.Decimal,
    numero_de_telefono: NativeFields.Int,
    sitio_de_internet: NativeFields.String,
    licencia_sanitaria: NativeFields.String,
    licencia_ecologica: NativeFields.String,
    registro_patronal_IMSS: NativeFields.String,
    numero_de_empleados: NativeFields.Int,
    ocupacion_maxima_de_empleados: NativeFields.Int,
    fecha_de_alta_de_padron: NativeFields.Date,
    fecha_de_apertura: NativeFields.Date,
    alta_SHCP: NativeFields.String,
    cajones_de_estacionamiento: NativeFields.Int,
    zona_de_carga_descarga: NativeFields.Decimal,
    observaciones: NativeFields.String,
    horarios: [HorarioSchema],
    tipo_de_establecimiento: TipoDeEstablecimientoSchema,
    predio: PredioSchema,
    padron: PadronSchema,
    regimen_de_empresa: RegimenDePropiedadSchema,
    estado_de_negocio: EstadoDeNegocioSchema,
    clasificacion_de_comercio: ClasificacionDeComercioSchema,
    sector_empresarial: SectorEmpresarialSchema,
    sucursal: SucursalDeEmpresaSchema,
    representantes: [CiudadanoSchema],
    tipo_empresa: TipoDeEmpresaSchema,
  },
  returnType: 'object',
  description: '',
};

const JuegoDeAzarSchema = {
  type: 'object',
  name: 'JuegoDeAzar',
  properties: {
    id: NativeFields.Int,
    clave_municipal: NativeFields.String,
    razon_social: NativeFields.String,
    nombre_comercial: NativeFields.String,
    es_persona_fisica: NativeFields.Boolean,
    RFC: NativeFields.String,
    superficie_del_terreno: NativeFields.Decimal,
    superficie_construida_del_terreno: NativeFields.Decimal,
    numero_de_telefono: NativeFields.Int,
    sitio_de_internet: NativeFields.String,
    licencia_sanitaria: NativeFields.String,
    licencia_ecologica: NativeFields.String,
    registro_patronal_IMSS: NativeFields.String,
    numero_de_empleados: NativeFields.Int,
    ocupacion_maxima_de_empleados: NativeFields.Int,
    fecha_de_alta_de_padron: NativeFields.Date,
    fecha_de_apertura: NativeFields.Date,
    alta_SHCP: NativeFields.String,
    cajones_de_estacionamiento: NativeFields.Int,
    zona_de_carga_descarga: NativeFields.Decimal,
    observaciones: NativeFields.String,
    horarios: [HorarioSchema],
    tipo_de_establecimiento: TipoDeEstablecimientoSchema,
    predio: PredioSchema,
    padron: PadronSchema,
    regimen_de_empresa: RegimenDePropiedadSchema,
    estado_de_negocio: EstadoDeNegocioSchema,
    clasificacion_de_comercio: ClasificacionDeComercioSchema,
    sector_empresarial: SectorEmpresarialSchema,
    sucursal: SucursalDeEmpresaSchema,
    representantes: [CiudadanoSchema],
    tipo_empresa: TipoDeEmpresaSchema,
  },
  returnType: 'object',
  description: '',
};

const output = [
  BandaDeValorSchema,
  CategoriaDePredioSchema,
  CategoriaDeRechazoSchema,
  TipoDeDominioSchema,
  TipoDeSueloSchema,
  RegimenDePropiedadSchema,
  UsoDePredioSchema,
  CalculoDeValorSchema,
  CalidadDeLaConstruccionSchema,
  ClasificacionDeLaConstruccionSchema,
  ConfiguracionDeClaveSchema,
  ConstruccionSchema,
  EstadoDeLaConstruccionSchema,
  FactoresEspecialesSchema,
  MeritoYDemeritoSchema,
  ParticipeSchema,
  TasaDAPRuralSchema,
  TasaDAPUrbanoSchema,
  TasaDeConstruccionDePredioUrbanoSchema,
  TasaDeConstruccionDePredioRuralSchema,
  TasaDePredioRuralSchema,
  TasaDePredioUrbanoSchema,
  TerrenoDelPredioSchema,
  TipoDeLaConstruccionSchema,
  ZonaHomogeneaSchema,
  CatalogoDeValorSchema,
  UMASchema,
  CPPSchema,
  INPCSchema,
  SalarioMinimoSchema,
  CanalDePagoSchema,
  SectorEmpresarialSchema,
  SubRamaEmpresarialSchema,
  SubSectorEmpresarialSchema,
  TipoDeEmpresaSchema,
  TipoDeEstablecimientoSchema,
  AnuncioSchema,
  CentroYPlazaSchema,
  EmpresaFiscalSchema,
  GiroDeEntidadSchema,
  SucursalDeEmpresaSchema,
  TipoDeCentroYPlazaSchema,
  EmpresaSchema,
  PredioSchema,
  VehiculoSchema,
  CiudadanoSchema,
  BandasDeValor,
  CategoriasDePredio,
  CategoriasDeRechazo,
  TiposDeDominio,
  TiposDeSuelo,
  RegimenesDePropiedad,
  UsosDePredio,
  CalculosDeValor,
  CalidadesDeConstruccion,
  ClasificacionesDeConstruccion,
  Construcciones,
  EstadosDeConstruccion,
  FactoresEspeciales,
  MeritosYDemeritos,
  Participes,
  TasasDAPRural,
  TasasDAPUrbano,
  TasasDeConstruccionDePredioUrbano,
  TasasDeConstruccionDePredioRural,
  TasasDePredioRural,
  TasasDePredioUrbano,
  TerrenosDePredio,
  TiposDeConstruccion,
  ZonasHomogeneas,
  CatalogoDeValor,
  UMA,
  CPP,
  INPC,
  SalariosMinimos,
  CanalesDePago,
  SectoresEmpresarial,
  SubRamasEmpresariales,
  SubSectoresEmpresariales,
  TiposDeEmpresas,
  TiposDeEstablecimiento,
  Anuncios,
  CentrosYPlazas,
  EmpresasFiscales,
  GirosDeEntidad,
  SucursalesDeEmpresas,
  TiposDeCentrosYPlazas,
  TodoSchema,
  HospedajeSchema,
  ArrendamientoSchema,
  NominaSchema,
  AlcoholSchema,
  CasaDeEmpenioSchema,
  AgenciaSchema,
  CedularSchema,
  NotarioSchema,
  JuegoDeAzarSchema,
];

export default output;
